import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchCouponHistory } from './queries/useFetchCouponHistory'

const CouponHistoryPage = () => {
	const { t } = useTranslation()

	const { couponHistory, isCouponHistoryLoading } = useFetchCouponHistory()

	return (
		<>
			<Header title={t('Coupon / History')} />
			<HistoryTable results={couponHistory?.data} isLoading={isCouponHistoryLoading} />
		</>
	)
}

export default CouponHistoryPage
